import { useEffect, useRef } from "react";
import L from "leaflet";
import "leaflet/dist/leaflet.css";

const pinIcon = L.divIcon({
  className: "",
  html: `<div style="transform:translate(-50%,-100%)">
    <svg width="34" height="46" viewBox="0 0 34 46" xmlns="http://www.w3.org/2000/svg">
      <path d="M17 0C7.6 0 0 7.6 0 17c0 12 17 29 17 29s17-17 17-29C34 7.6 26.4 0 17 0z" fill="#C47053"/>
      <circle cx="17" cy="17" r="6.5" fill="#F7F5F0"/>
    </svg></div>`,
  iconSize: [34, 46],
});

export default function RecMap({ items }) {
  const ref = useRef(null);
  const mapRef = useRef(null);

  useEffect(() => {
    const pts = items.filter((i) => typeof i.latitude === "number" && typeof i.longitude === "number");
    if (!ref.current) return;
    if (mapRef.current) { mapRef.current.remove(); mapRef.current = null; }

    const center = pts.length ? [pts[0].latitude, pts[0].longitude] : [33.4942, -111.9261];
    const map = L.map(ref.current, { scrollWheelZoom: false }).setView(center, 12);
    mapRef.current = map;

    L.tileLayer("https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png", {
      attribution: "&copy; OpenStreetMap",
      maxZoom: 19,
    }).addTo(map);

    const group = [];
    pts.forEach((p) => {
      const m = L.marker([p.latitude, p.longitude], { icon: pinIcon }).addTo(map);
      const dir = `https://maps.google.com/?q=${p.latitude},${p.longitude}`;
      m.bindPopup(
        `<div style="font-family:Manrope,sans-serif;min-width:160px">
          <div style="font-family:'Playfair Display',serif;font-size:16px;color:#2C3B2E;font-weight:600">${p.title}</div>
          <div style="font-size:12px;color:#555;margin:4px 0">${(p.description || "").slice(0, 90)}</div>
          <a href="${dir}" target="_blank" rel="noreferrer" style="font-size:12px;color:#C47053;font-weight:600;text-decoration:none">Get directions →</a>
        </div>`
      );
      group.push([p.latitude, p.longitude]);
    });
    if (group.length > 1) map.fitBounds(group, { padding: [40, 40], animate: false });

    const t = setTimeout(() => { if (mapRef.current === map) map.invalidateSize(); }, 200);
    return () => { clearTimeout(t); map.remove(); mapRef.current = null; };
  }, [items]);

  const hasPins = items.some((i) => typeof i.latitude === "number");

  return (
    <div className="relative">
      <div ref={ref} data-testid="rec-map" className="h-[520px] w-full rounded-3xl overflow-hidden border border-black/5 shadow-sm z-0" />
      {!hasPins && (
        <div className="absolute inset-0 flex items-center justify-center bg-white/70 rounded-3xl">
          <p className="text-brand-forest/60 text-center px-6">No mapped locations yet. Add coordinates to recommendations in the admin dashboard.</p>
        </div>
      )}
    </div>
  );
}
